import React from 'react';
import { Chip } from '@mui/material';
import { Text, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from "../../services/helpers";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { styled } from '@mui/styles';

/**
 *
 * @param {*} props
 */
export default function Dental({ classes, expanded, dental, handleChange, defineCoverageType, showDependentWarning, waivedDental }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('dental')}
                disableGutters={true}
                style={{ boxShadow: 'none' }}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root,
                        
                    }}
                    expandIcon={expanded.includes('dental') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.dental) }</Text>
                    {
                        waivedDental &&
                            <Chip
                                size="small"
                                label="Waived"
                                color="primary"
                                variant="outlined"
                                style={{
                                    margin: "0 10px",
                                    borderRadius: 30,
                                    borderWidth: 2,
                                    borderColor: Theme.colors.lightGrey,
                                    fontFamily: Theme.fonts.type.heading,
                                    fontSize: 14,
                                    color: '#666',
                                }}
                            />
                    }
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        dental.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                                </Text>
                            </div>
                            : 
                            null
                    }

                    {
                        showDependentWarning ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                   { i18n.t(tokens.labels.coverage.waivedBenefitsForDependents) }
                                </Text>
                            </div>
                            :
                            null
                    }

                    <Text small bold margin="20px 0px 10px 0px">
                        { i18n.t(tokens.labels.coverage.dentalWaitingPeriod, { eligibilityPeriod: dental.eligibilityPeriod, minHoursPerWeek: dental.minHoursPerWeek })}
                    </Text>

                    <div style={{ marginBottom: 10 }}>
                        {
                            dental.combineBasicAndMajor ?
                                <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.basicMajorCombinedMax, { basicMajorCombinedMax: numberWithCommas(dental.basicMajorCombinedMax) })}</Text>
                                :
                                <React.Fragment>
                                    {
                                        dental.includeMajor && dental.majorMax > 0 ?
                                            <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.majorMax, { majorMax: numberWithCommas(dental.majorMax) }) }</Text>
                                            : 
                                            null
                                    }
                                    {
                                        dental.includeBasic && dental.basicMax > 0 ?
                                            <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.basicMax, { basicMax: numberWithCommas(dental.basicMax) }) }</Text>
                                            : 
                                            null
                                    }
                                </React.Fragment>
                        }
                    </div>

                    <div>
                        {
                            dental.includeBasic ?
                                <React.Fragment>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.routineCareReimbursement, { routineCareReimbursement: dental.routineCareReimbursement }) }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.endodonticsReimbursement, { endodonticsReimbursement: dental.endodonticsReimbursement }) }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.periodonticsReimbursement, { periodonticsReimbursement: dental.periodonticsReimbursement })}</Text>
                                </React.Fragment>
                                : 
                                null
                        }

                        {
                            dental.includeMajor ?
                                <React.Fragment>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.bridgeWorkReimbursement, { bridgeWorkReimbursement: dental.bridgeWorkReimbursement }) }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.crownsReimbursement, { crownsReimbursement: dental.crownsReimbursement })}</Text>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.denturesReimbursement, { denturesReimbursement: dental.denturesReimbursement }) }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.dentureRepairReimbursement, { dentureRepairReimbursement: dental.dentureRepairReimbursement}) }</Text>
                                </React.Fragment>
                                : 
                                null
                        }

                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.unitsOfScaling, { unitsOfScaling: dental.unitsOfScaling }) }</Text>
                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.dentalRecall, { monthsToRecall: dental.monthsToRecall })}</Text>

                        {
                            dental.hasDeductible ?
                                defineCoverageType(dental)
                                : 
                                null
                        }

                        {
                            dental.includeOrthodontics ?
                                <React.Fragment>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.orthoLifetimeMax, { orthodonticLifetimeMax: dental.orthodonticLifetimeMax }) }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.orthodonticReimbursement, { orthodonticReimbursement: dental.orthodonticReimbursement }) }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.orthodonticsTermination, { orthodonticTerminationAge: dental.orthodonticTerminationAge }) }</Text>
                                </React.Fragment>
                                : 
                                null
                        }

                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.monthsSurvivorBenefit, { monthsSurvivorBenefit: dental.monthsSurvivorBenefit }) }</Text>
                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: dental.terminationAge }) }</Text>
                    </div>

                    <Text small bold margin="10px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.dentalReimbursementNote) }
                    </Text>
                </AccordionDetails>
            </Accordion>
        </div>
    )
};